export type Unit = 'px' | 'cm' | 'in'

export function convertUnitValue(
  preUnit: Unit | string,
  currUnit: Unit | string = 'px',
  value: { width: number; height: number },
): { width: number; height: number } {
  let { width, height } = value

  if (preUnit === 'px' && currUnit === 'cm') {
    width = (width * 2.54) / 96
    height = (height * 2.54) / 96
  } else if (preUnit === 'cm' && currUnit === 'px') {
    width = (width * 96) / 2.54
    height = (height * 96) / 2.54
  } else if (preUnit === 'px' && currUnit === 'in') {
    width = width / 96
    height = height / 96
  } else if (preUnit === 'in' && currUnit === 'px') {
    width = width * 96
    height = height * 96
  } else if (preUnit === 'cm' && currUnit === 'in') {
    width = width / 2.54
    height = height / 2.54
  } else if (preUnit === 'in' && currUnit === 'cm') {
    width = width * 2.54
    height = height * 2.54
  }

  width = currUnit === 'px' ? Math.round(width) : Number(width.toFixed(2))
  height = currUnit === 'px' ? Math.round(height) : Number(height.toFixed(2))
  return { width, height }
}
